<template>
  <div class="flex flex-col vld-parent">
    <loading :active.sync="$apollo.loading" :is-full-page="true" />
    <div class="px-2 mx-4 mt-4 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10 lg:mx-10">
      <div
        v-for="(area, index) in areas"
        :key="index"
        class="flex flex-col items-center justify-between w-full px-6 py-12 text-center border border-gray-200 shadow-xl md:w-4/5 md:flex-row rounded-md"
        @click="handleAreaClicked(index)"
      >
        {{ area.name }}
      </div>
    </div>
  </div>
</template>

<script>
import GET_AREAS from '@/graphql/GetAreas';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Areas',
  apollo: {
    areas: { query: GET_AREAS, update: (data) => data.AreaMany },
  },
  methods: {
    ...mapMutations(['setActiveArea']),
    handleAreaClicked(index) {
      this.setActiveArea(this.areas[index]);
      // eslint-disable-next-line no-underscore-dangle
      this.$router.push({ path: `/areas/${this.areas[index]._id}` });
    },
  },
  computed: {
    ...mapGetters(['activeArea']),
  },
};
</script>

<style></style>
